import {EventEmitter, Injectable} from "@angular/core";


@Injectable({providedIn: 'root'})
export class SitesMapService {
  loadMap = new EventEmitter(true);
}
